"use client";

import Image, { ImageProps } from "next/image";
import { useState } from "react";

interface GlobalImageProps extends Partial<ImageProps> {
  src: string;
  alt?: string;
  width: number;
  height: number;
  className?: string;
  priority?: boolean;
  rounded?: boolean;
  objectFit?: "contain" | "cover" | "fill" | "none" | "scale-down";
}

const GlobalImageComponent = ({
  src,
  alt = "image",
  width,
  height,
  className = "",
  priority = false,
  rounded = false,
  objectFit = "cover",
  ...rest
}: GlobalImageProps) => {
  const [error, setError] = useState(false);

  return (
    <div
      className={`relative overflow-hidden ${
        rounded ? "rounded-lg" : ""
      } ${className}`}
      style={{ width, height }}
    >
      {error ? (
        <div className="w-full h-full bg-gray-300 grid place-items-center text-gray-600 text-sm">
          Failed to load
        </div>
      ) : (
        <Image
          src={src}
          alt={alt}
          width={width}
          height={height}
          priority={priority}
          onError={() => setError(true)}
          className="w-full h-full transition-all duration-500"
          style={{ objectFit: objectFit }}
          placeholder="blur"
          blurDataURL="/blur-placeholder.png"
          {...rest}
        />
      )}
    </div>
  );
};

export default GlobalImageComponent;
